import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import ServicesPage from "@/pages/ServicesPage";
import WorkPage from "@/pages/WorkPage";
import ProcessPage from "@/pages/ProcessPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import ComponentsPage from "@/pages/ComponentsPage";
import BlogPage from "@/pages/BlogPage";
import BlogPost from "@/pages/BlogPost";
import SponsorPage from "@/pages/SponsorPage";
import CareersPage from "@/pages/CareersPage";
import { TermsPage, PrivacyPage } from "@/pages/LegalPages";
import CaseStudy from "@/pages/CaseStudy";
import { HeroesIndex, HeroVariantPage } from "@/pages/HeroVariants";
import LogoPage from "@/pages/LogoPage";
import BrandPage from "@/pages/BrandPage";
import SecretPage from "@/pages/SecretPage";
import NotFoundPage from "@/pages/NotFoundPage";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { EasterEggsProvider } from "@/components/EasterEggs";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <EasterEggsProvider>
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/work" element={<WorkPage />} />
            <Route path="/work/:slug" element={<CaseStudy />} />
            <Route path="/process" element={<ProcessPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/components" element={<ComponentsPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/sponsor" element={<SponsorPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/heroes" element={<HeroesIndex />} />
            <Route path="/hero-1" element={<HeroVariantPage />} />
            <Route path="/hero-2" element={<HeroVariantPage />} />
            <Route path="/hero-3" element={<HeroVariantPage />} />
            <Route path="/hero-4" element={<HeroVariantPage />} />
            <Route path="/hero-5" element={<HeroVariantPage />} />
            <Route path="/logo" element={<LogoPage />} />
            <Route path="/brand" element={<BrandPage />} />
            <Route path="/secret" element={<SecretPage />} />
            <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </EasterEggsProvider>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
